import styled, { css } from "styled-components";

// 스켈레톤 로딩 스타일
const shimmer = css`
  background: linear-gradient(
    90deg,
    rgb(231, 231, 231) 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

export const SkeletonLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SkeletonRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SkeletonText = styled.div<{
  width?: string;
  height?: string;
  marginTop?: string;
}>`
  ${shimmer}
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "14px"};
  border-radius: 4px;
  margin-top: ${({ marginTop }) => marginTop || "0"};
`;

export const SkeletonIcon = styled.div`
  ${shimmer}
  width: 24px;
  height: 24px;
  border-radius: 4px;
  flex-shrink: 0;
`;
